

//start for cart cupons
function initAccordion(scope = document) {
  scope.querySelectorAll(".accordion-button").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const content = btn.nextElementSibling;
      if (!content || !content.classList.contains("accordion-content")) return;

      const arrow = btn.querySelector(".arrow");
      const isOpen = content.classList.contains("open");

      // close all
      scope.querySelectorAll(".accordion-content.open").forEach(el => {
        el.classList.remove("open");
        el.style.maxHeight = null;
      });

      // toggle current
      if (!isOpen) {
        content.classList.add("open");
        content.style.maxHeight = content.scrollHeight + "px";
        if (arrow) arrow.style.transform = "rotate(180deg)";
      } else {
        if (arrow) arrow.style.transform = "rotate(0deg)";
      }
    });
  });
}

// initial load
document.addEventListener("DOMContentLoaded", () => {
  initAccordion();
});

// cart redraw / theme editor
document.addEventListener("shopify:section:load", (e) => {
  initAccordion(e.target);
});
//end of cart cupons

document.addEventListener("click", function (e) {
  const cartIcon = e.target.closest(".cart-icon");
  if (!cartIcon) return;

  e.preventDefault();
  window.location.href = "/cart";
});



  document.addEventListener("DOMContentLoaded", function () {

  const productForm = document.querySelector('[data-product-form]');
  if (!productForm) return;

  const variantSelect = productForm.querySelector('select[name="id"]');
  if (!variantSelect) return;

  document.querySelectorAll('.color-swatch').forEach(function (swatch) {
    swatch.addEventListener('change', function () {

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      // 1️⃣ Update main variant select
      variantSelect.value = variantId;

      // 2️⃣ Fire Shopify change event
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

      // 3️⃣ Update image manually (your theme needs this)
      const targetImage = document.querySelector(
        '.product-single__photo[data-image-id]'
      );

      const productData = JSON.parse(
        document.getElementById('ProductJson-{{ section.id }}').textContent
      );

      const variant = productData.variants.find(v => v.id == variantId);

      if (variant && variant.featured_image) {
        document.querySelectorAll('.product-single__photo-wrapper').forEach(img => {
          img.style.display = 'none';
        });

        const imgToShow = document.querySelector(
          '[data-image-id="' + variant.featured_image.id + '"]'
        );

        if (imgToShow) {
          imgToShow.closest('.product-single__photo-wrapper').style.display = 'block';
        }
      }

    });
  });
});

// Horizontal thumbnail navigation for product images (Amazon style)
// Fix: thumbnail click must change the main image via Slick asNavFor sync
(function() {
  if (typeof jQuery === 'undefined') return;
  
  function initProductImageSync() {
    var $ = jQuery;
    
    // ---------- DEFAULT TEMPLATE (page-product-detail-default) ----------
    // Skip Slick when new card gallery is present (product-gallery-card.liquid).
    if (!$('.page-product-detail-default .product-gallery[data-product-gallery]').length) {
      var $defaultSlider = $('.page-product-detail-default .product-slider');
      if ($defaultSlider.length) {
        var $defaultFor = $defaultSlider.find('.slider-for');
        var $defaultNav = $defaultSlider.find('.slider-nav');
        
        if ($defaultFor.length && $defaultNav.length) {
          if ($defaultNav.hasClass('slick-initialized')) {
            $defaultNav.slick('unslick');
          }
          if ($defaultFor.hasClass('slick-initialized')) {
            $defaultFor.slick('unslick');
          }
          
          $defaultFor.slick({
            rows: 0,
            fade: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            infinite: false
          });
          
          $defaultNav.slick({
            rows: 0,
            infinite: true,
            vertical: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            focusOnSelect: true,
            asNavFor: $defaultFor,
            touchThreshold: 10,
            swipeToSlide: true,
            prevArrow: '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-left"></svg></div>',
            nextArrow: '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-right"></svg></div>',
            responsive: [
              { breakpoint: 992, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true, swipeToSlide: true } },
              { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1, infinite: false, swipeToSlide: true } },
              { breakpoint: 550, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: false, swipeToSlide: true } }
            ]
          });
          $defaultNav.find('.product-single__thumbnail').off('click');
        }
      }
    }
    
    // ---------- TEMPLATE-01 (ProductSection-product-template-01) ----------
    // Theme already inits both with asNavFor. Force horizontal and ensure sync.
    var $t01Slider = $('#ProductSection-product-template-01 .product_layout .product_photos .product-slider');
    if ($t01Slider.length) {
      var $t01For = $t01Slider.find('.slider-for');
      var $t01Nav = $t01Slider.find('.slider-nav');
      
      if ($t01For.length && $t01Nav.length) {
        if ($t01Nav.hasClass('slick-initialized')) {
          $t01Nav.slick('unslick');
        }
        if ($t01For.hasClass('slick-initialized')) {
          $t01For.slick('unslick');
        }
        
        $t01For.slick({
          rows: 0,
          fade: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: $t01Nav,
          adaptiveHeight: true
        });
        
        $t01Nav.slick({
          rows: 0,
          infinite: true,
          vertical: false,
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: true,
          focusOnSelect: true,
          asNavFor: $t01For,
          touchThreshold: 10,
          swipeToSlide: true,
          prevArrow: '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-left"></svg></div>',
          nextArrow: '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-right"></svg></div>',
          responsive: [
            { breakpoint: 992, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true, swipeToSlide: true } },
            { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1, infinite: false, swipeToSlide: true } },
            { breakpoint: 550, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: false, swipeToSlide: true } }
          ]
        });
      }
    }
  }
  
  jQuery(document).ready(function($) {
    // Prevent thumbnail link navigation; scroll up to main image only when main image is not in view
    $(document).on('click', '.product-slider .slider-nav .product-single__thumbnail, .product-slider .slider-nav a[href][data-thumbnail-id], .product-slider .slider-nav .item a', function(e) {
      var $nav = $(this).closest('.slider-nav');
      if (!$nav.length || !$nav.hasClass('slick-initialized')) return;
      e.preventDefault();
      var $mainImage = $nav.closest('.product-slider').find('.slider-for').first();
      if (!$mainImage.length) return;
      var mainImageTop = $mainImage.offset().top - 80;
      var scrollTolerance = 60;
      // Only scroll when user has scrolled down past the main image (main image not in view above)
      if ($(window).scrollTop() > mainImageTop + scrollTolerance) {
        setTimeout(function() {
          $('html, body').animate({ scrollTop: Math.max(0, mainImageTop) }, 320);
        }, 50);
      }
    });
    
    // Variant change: sync new card gallery to variant's featured image
    $(document).on('variantChange', function(evt) {
      if (!evt.variant || !evt.variant.featured_media) return;
      var $container = $(evt.target);
      if (!$container.find('.product-gallery[data-product-gallery]').length) return;
      if (window.MiraviProductGallery && window.MiraviProductGallery.goToMediaId) {
        window.MiraviProductGallery.goToMediaId(evt.variant.featured_media.id);
      }
    });

    // Run after theme's Product section has run
    setTimeout(initProductImageSync, 300);
    setTimeout(initProductImageSync, 1200);
    $(document).on('shopify:section:load', function() {
      setTimeout(initProductImageSync, 400);
    });
  });
  
})();